"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classNames = require("classnames");
var Checkbox_1 = require("../Checkbox");
var Typography_1 = require("../Typography");
var CheckboxGroup = /** @class */ (function (_super) {
    __extends(CheckboxGroup, _super);
    function CheckboxGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, _b = _a.direction, direction = _b === void 0 ? 'row' : _b, checkboxes = _a.checkboxes, title = _a.title, values = _a.values;
        var renderCheckboxes = checkboxes.map(function (_a, key) {
            var id = _a.id, label = _a.label, disabled = _a.disabled;
            var isChecked = values.includes(id);
            return (React.createElement(Checkbox_1.default, { className: styles.checkbox, key: key, label: label, disabled: disabled, onChange: function () {
                    if (isChecked) {
                        var nextValues = values.slice();
                        var findItemIndex = nextValues.findIndex(function (currentId) { return currentId === id; });
                        if (findItemIndex !== -1) {
                            nextValues.splice(findItemIndex, 1);
                            _this.props.onChange(nextValues);
                        }
                    }
                    else {
                        _this.props.onChange(values.concat([id]));
                    }
                }, checked: isChecked }));
        });
        var isColumn = direction === 'column';
        return (React.createElement("div", { className: classNames(styles.checkboxGroup, className, isColumn && styles.isColumn) },
            title && React.createElement(Typography_1.default, { component: "field" }, title),
            React.createElement("div", { className: styles.checkboxes }, renderCheckboxes)));
    };
    return CheckboxGroup;
}(React.Component));
exports.default = CheckboxGroup;
